export default function debounce( callback, timeout ) {
	let timer;
	return function( ...args ) {
		clearTimeout( timer );
		timer = setTimeout( () => callback.apply( this, ...args ), timeout );
	};
}
